import { forwardRef, Ref, SyntheticEvent, useState } from "react"
import { Form, Formik, FormikProps } from "formik"
import { TabsOrder } from "./formConstants"
import { BookingTimeType, CreateCarResourceForm } from "../../resourcesTypes"
import { TabPanel } from "../../../../../../../shared/components/tabs/tabPanel"
import * as yup from "yup"
import { useAppLocalization } from "../../../../../../localization/components/AppLocalizationProvider"
import { CarFormTabs } from "./CarFormTabs"
import { FormCarGeneralContent } from "./general/FormCarGeneralContent"
import { AccessControl } from "../room/accessControl/AccessControl"
import { AvailabilityContent } from "../room/availability/AvailabilityContent"

type CreateUpdateCarFormProps = Readonly<{
    initialValues?: CreateCarResourceForm | null
    onSubmit: (formData: CreateCarResourceForm) => void
}>

const defaultInitialValues: CreateCarResourceForm = {
    name: "",
    isActive: false,
    image: {
        uid: "",
    },
    description: "",
    accessControl: {
        limitAccess: false,
        visibleForAll: false,
        departmentIds: [],
    },
    notifications: [],
    tags: [],
    closingTimes: [],
    carDetails: {
        type: "",
        status: "",
        registrationNumber: "",
        parkingLocation: "",
        keysLocation: "",
    },
    bookingTimeType: BookingTimeType.ACCEPT_BOOKING_TIME,
}

type FormikRef = Ref<FormikProps<CreateCarResourceForm>>

export const CreateUpdateCarForm = forwardRef(
    ({ initialValues, onSubmit }: CreateUpdateCarFormProps, ref: FormikRef) => {
        const { l10n } = useAppLocalization()
        const [value, setValue] = useState(TabsOrder.GENERAL)

        const onTabChange = (_event: SyntheticEvent, newValue: number) => {
            setValue(newValue)
        }

        const validationSchema = yup.object({
            name: yup.string().required(l10n.getString("required-field")),
        })

        function handleSubmit(values: CreateCarResourceForm) {
            onSubmit(values)
        }

        return (
            <Formik<CreateCarResourceForm>
                enableReinitialize
                initialValues={initialValues ? initialValues : defaultInitialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                innerRef={ref}
            >
                <Form>
                    <CarFormTabs value={value} onChange={onTabChange} />
                    <TabPanel value={value} index={TabsOrder.GENERAL}>
                        <FormCarGeneralContent />
                    </TabPanel>

                    <TabPanel value={value} index={TabsOrder.AVAILABILITY}>
                        <AvailabilityContent />
                    </TabPanel>

                    <TabPanel value={value} index={TabsOrder.ACCESS_CONTROL}>
                        <AccessControl />
                    </TabPanel>
                </Form>
            </Formik>
        )
    },
)
